import { EventEmitter } from "@angular/core";
import { Subject } from "rxjs/Subject";
/**
 * Event triggered when a value for a filter changes
 */
export class FilterValueChangedEvent {
    constructor(filterName, value) {
        this.filterName = filterName;
        this.value = value;
    }
}
export class AbstractSearchModel {
    constructor() {
        /**
         * emits events when a specific field value changes
         * @type {EventEmitter<FilterValueChangedEvent>}
         */
        this.filterFieldChange = new EventEmitter();
        /**
         * emits an event when the filter has changed
         * @type {EventEmitter}
         */
        this.filterChange = new EventEmitter();
        this.clearFilterOptions$ = new Subject();
    }
}
//# sourceMappingURL=abstract-search.model.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/resource/search/abstract-search.model.js
// module id = 75
// module chunks = 1